import React, {useEffect, useState} from 'react';

import {Button} from '../../../../services/weave-python/weave-public/weave-js/src/components';
import {Email, EmailType} from '../generated/graphql';
import {
  AccountIcon,
  AccountIconLocation,
} from '../pages/Billing/AccountSettings/AccountIcon';
import {AccountType} from './Search/SearchNav/AccountSelectorContextProvider';
import * as S from './WBUsageTypeSelection.styles';

export enum UsageType {
  Personal = 'personal',
  Corporate = 'corporate',
  Academic = 'academic',
}

type Props = {
  verifiedViewerEmailDomainTypes?: EmailType[];
  viewerEmails?: Email[];
  onUsageTypeChange: (usageType: AccountType) => void;
  onClickContinue: (needsToAddWorkEmail: boolean) => void;
  isTransitioningPage: boolean;
};

export const WBUsageTypeSelection = ({
  verifiedViewerEmailDomainTypes,
  onUsageTypeChange,
  onClickContinue,
  isTransitioningPage,
}: Props) => {
  const hasVerifiedCorporateEmail = verifiedViewerEmailDomainTypes?.includes(
    EmailType.Corporate
  );
  const [usageType, setUsageType] = useState<AccountType | null>(null);

  useEffect(() => {
    if (usageType == null) {
      return;
    }
    try {
      onUsageTypeChange(usageType);
    } catch (e) {
      console.error(e);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [usageType]);

  const usageTypeOptions = [
    {
      label: 'Work',
      value: AccountType.Corporate,
      description: 'Use W&B to collaborate with your colleagues at work.',
    },
    {
      label: 'Academic',
      value: AccountType.Academic,
      description: 'Use W&B for research or education.',
    },
    {
      label: 'Personal',
      value: AccountType.Personal,
      description: 'Use W&B for personal projects without team collaboration.',
    },
  ];

  const handleClickContinue = () => {
    const needsToAddWorkEmail =
      usageType === AccountType.Corporate && !hasVerifiedCorporateEmail;
    onClickContinue(needsToAddWorkEmail);
  };

  return (
    <>
      <S.MainContainer>
        {usageTypeOptions.map(({label, value, description}) => (
          <S.SelectionItemContainer
            key={value}
            data-test={`usage-type-${value.toLowerCase()}`}
            $selected={usageType === value}
            onClick={() => setUsageType(value)}>
            <S.IconAndTextContainer>
              <AccountIcon
                isSelected={usageType === value}
                location={AccountIconLocation.Onboarding}
                accountType={value}
              />
              <S.ItemLabelAndDescriptionContainer>
                <S.ItemLabel>
                  <div>{label}</div>
                  {value === AccountType.Corporate && (
                    <S.Label>Most Popular</S.Label>
                  )}
                </S.ItemLabel>
                <S.ItemDescription>{description}</S.ItemDescription>
              </S.ItemLabelAndDescriptionContainer>
            </S.IconAndTextContainer>
            <S.Checkmark selected={usageType === value} />
          </S.SelectionItemContainer>
        ))}
      </S.MainContainer>
      <Button
        className="w-full"
        size="large"
        data-test="continue-button"
        disabled={usageType == null || isTransitioningPage}
        onClick={() => {
          handleClickContinue();
        }}>
        Continue
      </Button>
    </>
  );
};
